import { Upload } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import SecureDocumentUploadsPage from "./pages/SecureDocumentUploadsPage";

const SecureDocumentUploadsRouter: NavigationLinkProps[] = [
  {
    id: "bc5883cc-e1e2-4d62-aaa5-0c88e3bf0510",
    title: "Secure File Upload",
    description: "",
    path: "/secure-file-upload",
    auth: true,
    sidebar: true,
    secondarySidebar: false,
    icon: Upload,
    component: SecureDocumentUploadsPage,
    requiredFeature: "ANY",
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.SECURE_EMPLOYER_UPLOADS,
    isFeatureFlagged: true,
  },
];

export default SecureDocumentUploadsRouter;
